import { useCommandBar } from "../hooks/useCommandBar";
import { useRecordNavigationClick } from "../hooks/useRecordNavigationClick";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";

export function SearchButton({ showLabel = false }: { showLabel?: boolean }) {
  const { open, toggle } = useCommandBar();
  const recordClick = useRecordNavigationClick();

  const button = (
    <Button
      variant="subtle"
      size="l"
      icon="search"
      onPointerDownCapture={(event) => event.preventDefault()}
      onClick={() => {
        if (!open) recordClick(showLabel ? "sidebar" : "top_bar", "search");
        toggle();
      }}
      aria-label="Search"
      style={
        showLabel
          ? { width: "100%", justifyContent: "center", borderRadius: 999 }
          : undefined
      }
    >
      {showLabel ? "Search" : undefined}
    </Button>
  );

  if (showLabel) return button;

  return (
    <Tooltip
      content={
        <>
          Search{" "}
          <span style={{ fontSize: 10, color: "var(--text-secondary)" }}>
            ⌘K
          </span>
        </>
      }
    >
      {button}
    </Tooltip>
  );
}
